import React, { useEffect, useState } from 'react';
import FooterServices from '../../components/FooterServices';
import { Helmet } from "react-helmet";
import BannerSection from "./modules/BannerSection";
import ProductSection from "./modules/ProductSection";
import ShopCategory from "./modules/ShopCategory";
import ClientsSection from "./modules/ClientsSection";
import ProjectSection from "./modules/ProjectSection";
import StoriesSection from "./modules/StoriesSection";
import BlogSection from "./modules/BlogSection";
import VideoSection from "./modules/VideoSection";
import AboutSection from "./modules/AboutSection";
import api from '../../api';
import HeroSection from './modules/HeroSection';
import TestimonialSection from './modules/TestimonialSection';

export default function Home({ handleCart, handleWishlist }) {
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [metaData, setMetaData] = useState({});
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get('/business-settings');
                setSettings(response.data.data.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (settings.length > 0) {
            const meta = {};
            settings.forEach(setting => {
                if (setting.type === "header_logo_path") {
                    meta.header_logo_path = setting.value;
                }
                if (setting.type === 'meta_title') {
                    meta.meta_title = setting.value;
                }
                if (setting.type === 'meta_keywords') {
                    meta.meta_keywords = setting.value;
                }
                if (setting.type === 'meta_description') {
                    meta.meta_description = setting.value;
                }
                if (setting.type === 'website_name') {
                    meta.website_name = setting.value;
                }
                if (setting.type === 'facebook_link') {
                    meta.facebook_link = setting.value;
                }
                if (setting.type === 'twitter_link') {
                    meta.twitter_link = setting.value;
                }
                if (setting.type === 'instagram_link') {
                    meta.instagram_link = setting.value;
                }
                if (setting.type === 'youtube_link') {
                    meta.youtube_link = setting.value;
                }
            });
            setMetaData(meta);
        }
    }, [settings]);

    if (error) return <div>Error: {error.message}</div>;

    return (
        <>
            <Helmet>
                <title>{metaData.meta_title}</title>
                <meta name="title" content={metaData.meta_title} />
                <meta name="description" content={metaData.meta_description} />
                <meta property="og:title" content={metaData.meta_title} />
                <meta property="og:site_name" content={metaData.website_name} />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:description" content={metaData.meta_description} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={metaData.header_logo_path} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@niyaiving" />
                <meta name="twitter:title" content={metaData.meta_title} />
                <meta name="twitter:description" content={metaData.meta_description} />
                <meta name="twitter:image" content={metaData.header_logo_path} />
                <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
            </Helmet>
            
            <BannerSection />
            <ShopCategory />
            <AboutSection />
            
            {/* <ProductSection handleCart={handleCart} handleWishlist={handleWishlist} /> */}
            <HeroSection />
            <BlogSection />          
            <TestimonialSection />
            <FooterServices />
        </>
    );
}
